import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth as oidcAuth } from 'react-oidc-context';
import { selectCurrentUser } from '../slice/authSlice';
import { persistor } from '../store';
import { api } from '../services/api';
import { isAuthorized } from '../utils/userUtils';

/**
 * Hook used to handle current user.
 * @returns {{isAuthorized: function(*, *): *, user: unknown}}
 */
export const useAuth = () => {
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const authOIDC = oidcAuth();

  const currentUser = useMemo(
    () => ({
      user,
      isAuthorized: (functionality, operation) => isAuthorized(user, functionality, operation)
    }),
    [user]
  );

  const logout = (oidcEnabled) => {
    persistor.purge();
    dispatch(api.util.resetApiState());

    if (oidcEnabled || authOIDC?.isAuthenticated) {
      resetOIDCState();
    } else {
      window.location.assign(
        `${window.location.href.substring(0, window.location.href.indexOf('#') + 1)}/signIn`
      );
      window.location.reload();
    }
  };

  /**
   * Remove OIDC keys from localStorage
   */
  // function clearOIDCLocalStorage() {
  //   Object.keys(localStorage).forEach((key) => {
  //     if (key.startsWith('oidc')) {
  //       localStorage.removeItem(key);
  //     }
  //   });
  // }

  /**
   * Reset oidc state from session, cache and local storage
   */
  function resetOIDCState() {
    authOIDC.signoutSilent();
    // authOIDC.signoutSilent().then(() => {
    //   clearOIDCLocalStorage();
    //   authOIDC.revokeTokens();
    //   authOIDC?.removeUser();
    //   dispatch(setToken(null));
    // });
  }

  return { currentUser, logout };
};
